
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IMetadata, IMetadataFilter, IFormule } from '../../model/dataset.model';
import { HttpWrapper } from '../../http/HttpWrapper';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MetadataService {

  constructor(private httpWrapper: HttpWrapper,  @Inject(APP_CONFIG) private config: IAppConfig,
  private http: HttpClient
  ) { }

  enpoint: string = this.config.endpointMetadata;

  callBackend(appcontext:string) {
    //return this.httpWrapper._request(RequestMethod.Get, this.enpoint + '?appcontext=' + appcontext, null, null, ResponseContentType.Json, false)
    let uri = this.enpoint + '?appcontext=' + appcontext;
    return this.http.get(uri, { observe: 'response', responseType: 'json' })
      .pipe(map((res: any) => res),
      catchError((error: any) => Observable.throw(error || 'Server error')));
  }

  parseMetadata(jsonFile: any): IMetadata {
    const metadata: IMetadata = {
      appcontext: jsonFile['appcontext']
      }
    return metadata;
  }

}
